 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"dashboard~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-~8816e537":"dashboard~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-~8816e537","pages~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-a~16e7ff7f":"pages~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-a~16e7ff7f","pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-an~page~b3e22ddc":"pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-an~page~b3e22ddc","pages-gb-an":"pages-gb-an","pages-mg-ad":"pages-mg-ad","dashboard~pages-gb-ad~pages-gb-af~pages-mg-an~pages-wc-af~pages-wd-ad~pages-wd-af~pages-wm-ad~pages-~84ad0fa0":"dashboard~pages-gb-ad~pages-gb-af~pages-mg-an~pages-wc-af~pages-wd-ad~pages-wd-af~pages-wm-ad~pages-~84ad0fa0","dashboard~pages-wc-af~pages-wd-af":"dashboard~pages-wc-af~pages-wd-af","dashboard":"dashboard","pages-gb-ad":"pages-gb-ad","pages-gb-af":"pages-gb-af","pages-mg-an":"pages-mg-an","pages-wd-ad":"pages-wd-ad","pages-wm-ad":"pages-wm-ad","pages-wm-an":"pages-wm-an","pages-wp-ad":"pages-wp-ad","pages-wp-af":"pages-wp-af","pages-wp-an":"pages-wp-an","reel-time-stats":"reel-time-stats","pages-wc-af":"pages-wc-af","pages-wd-af":"pages-wd-af","pages-crm-salon":"pages-crm-salon","pages":"pages"}[chunkId]||chunkId) + "." + {"chunk-67042942":"452394b8","chunk-76d45e16":"78f1de99","dashboard~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-~8816e537":"42e0c550","pages~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-a~16e7ff7f":"a02fd160","pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-an~page~b3e22ddc":"efea50c4","pages-gb-an":"fc0c7c47","pages-mg-ad":"ce32a7eb","dashboard~pages-gb-ad~pages-gb-af~pages-mg-an~pages-wc-af~pages-wd-ad~pages-wd-af~pages-wm-ad~pages-~84ad0fa0":"82b59f60","dashboard~pages-wc-af~pages-wd-af":"1fe5c0c6","dashboard":"f5417234","pages-gb-ad":"0e0555ab","pages-gb-af":"6c082a3e","pages-mg-an":"cc8347e6","pages-wd-ad":"adff788b","pages-wm-ad":"692d43b3","pages-wm-an":"06cf4115","pages-wp-ad":"a8b017da","pages-wp-af":"dcd57ec0","pages-wp-an":"c2c7fb45","reel-time-stats":"256b882e","pages-wc-af":"37ea2cf4","pages-wd-af":"f2ab943f","pages-crm-salon":"2416de27","pages":"febc05ec","chunk-01b70b16":"e7270bc0","chunk-2d216214":"54a2eb31"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-76d45e16":1,"dashboard~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-~8816e537":1,"pages~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-a~16e7ff7f":1,"pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-an~page~b3e22ddc":1,"pages-mg-ad":1,"dashboard":1,"pages-gb-ad":1,"pages-gb-af":1,"pages-wd-ad":1,"pages-wm-ad":1,"pages-wm-an":1,"pages-wp-ad":1,"pages-wp-af":1,"pages-wp-an":1,"reel-time-stats":1,"pages":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"dashboard~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-~8816e537":"dashboard~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-~8816e537","pages~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-a~16e7ff7f":"pages~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-a~16e7ff7f","pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-an~page~b3e22ddc":"pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-an~page~b3e22ddc","pages-gb-an":"pages-gb-an","pages-mg-ad":"pages-mg-ad","dashboard~pages-gb-ad~pages-gb-af~pages-mg-an~pages-wc-af~pages-wd-ad~pages-wd-af~pages-wm-ad~pages-~84ad0fa0":"dashboard~pages-gb-ad~pages-gb-af~pages-mg-an~pages-wc-af~pages-wd-ad~pages-wd-af~pages-wm-ad~pages-~84ad0fa0","dashboard~pages-wc-af~pages-wd-af":"dashboard~pages-wc-af~pages-wd-af","dashboard":"dashboard","pages-gb-ad":"pages-gb-ad","pages-gb-af":"pages-gb-af","pages-mg-an":"pages-mg-an","pages-wd-ad":"pages-wd-ad","pages-wm-ad":"pages-wm-ad","pages-wm-an":"pages-wm-an","pages-wp-ad":"pages-wp-ad","pages-wp-af":"pages-wp-af","pages-wp-an":"pages-wp-an","reel-time-stats":"reel-time-stats","pages-wc-af":"pages-wc-af","pages-wd-af":"pages-wd-af","pages-crm-salon":"pages-crm-salon","pages":"pages"}[chunkId]||chunkId) + "." + {"chunk-67042942":"31d6cfe0","chunk-76d45e16":"e6e493b2","dashboard~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-~8816e537":"c39fea71","pages~pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-a~16e7ff7f":"7568e997","pages-gb-ad~pages-gb-af~pages-gb-an~pages-mg-ad~pages-mg-an~pages-wd-ad~pages-wm-ad~pages-wm-an~page~b3e22ddc":"d58f8a3b","pages-gb-an":"31d6cfe0","pages-mg-ad":"32937a0c","dashboard~pages-gb-ad~pages-gb-af~pages-mg-an~pages-wc-af~pages-wd-ad~pages-wd-af~pages-wm-ad~pages-~84ad0fa0":"31d6cfe0","dashboard~pages-wc-af~pages-wd-af":"31d6cfe0","dashboard":"bf3f6d2e","pages-gb-ad":"2757b13a","pages-gb-af":"7c4e5a0f","pages-mg-an":"31d6cfe0","pages-wd-ad":"3a9511e6","pages-wm-ad":"bd44d316","pages-wm-an":"60a35506","pages-wp-ad":"52616c7e","pages-wp-af":"3963f13a","pages-wp-an":"cb8ffcb2","reel-time-stats":"481074ee","pages-wc-af":"31d6cfe0","pages-wd-af":"31d6cfe0","pages-crm-salon":"31d6cfe0","pages":"978c3001","chunk-01b70b16":"31d6cfe0","chunk-2d216214":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
